import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';
import {CardBase} from '@yandex-data-ui/page-constructor';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import ServiceLogo from 'units/constructor-local/components/ServiceLogo/ServiceLogo';
import ServiceTag from 'units/constructor-local/components/ServiceTag/ServiceTag';
import {ServicePreviewCardProps as ServicePreviewCardParams} from 'units/constructor-local/models';

import './ServicePreviewCard.scss';

const b = block('service-preview-card');

export type ServicePreviewCardProps = ServicePreviewCardParams &
    WithTranslationProps &
    ClassNameProps;

const ServicePreviewCard: React.FC<ServicePreviewCardProps> = (props) => {
    const {i18nK, slug, name, description, tag, status, docUrl, pricesUrl, border, className} =
        props;

    return (
        <CardBase
            className={b(null, className)}
            url={`/services/${slug}`}
            border={border}
            contentClassName={b('content')}
        >
            <CardBase.Content>
                <div className={b('content-top')}>
                    <div className={b('logo-tag')}>
                        <ServiceLogo service={slug} />
                        <ServiceTag className={b('tag')} tag={tag} status={status} />
                    </div>
                    <h6 className={b('title')}>
                        <HTML>{name}</HTML>
                    </h6>
                    {description && <HTML>{description}</HTML>}
                </div>
                <div className={b('links')}>
                    {docUrl && <a href={docUrl}>{i18nK('doc-link')}</a>}
                    {pricesUrl && <a href={pricesUrl}>{i18nK('prices-link')}</a>}
                </div>
            </CardBase.Content>
        </CardBase>
    );
};

export default withTranslation('services')(ServicePreviewCard);
